import { render, staticRenderFns } from "./cadastrar-servicos-preco.vue?vue&type=template&id=89cf3276&scoped=true&"
import script from "./cadastrar-servicos-preco.vue?vue&type=script&lang=js&"
export * from "./cadastrar-servicos-preco.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-servicos-preco.vue?vue&type=style&index=0&id=89cf3276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cf3276",
  null
  
)

export default component.exports